var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.6119 4.50001C16.3819 4.20101 16.1379 3.91001 15.8639 3.63601C12.3489 0.121006 6.65094 0.121006 3.13594 3.63601C2.86194 3.91001 2.61894 4.20101 2.38794 4.50001",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.38794 15.5C2.61794 15.799 2.86194 16.09 3.13594 16.364C6.65094 19.879 12.3489 19.879 15.8639 16.364C16.1379 16.09 16.3809 15.799 16.6119 15.5",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.021 12.571H1V10.04H4.019C4.718 10.04 5.285 10.607 5.285 11.306V11.306C5.286 12.005 4.719 12.571 4.021 12.571Z",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.04V7.42896H3.7C4.421 7.42896 5.006 8.01396 5.006 8.73496V8.73496C5.006 9.45596 4.421 10.041 3.7 10.041",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.714 7.42896L16.857 10.344L19 7.42896",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.86 12.53V10.34",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1431 7.42896V10.429C12.1431 11.612 11.1841 12.572 10.0001 12.572V12.572C8.81706 12.572 7.85706 11.613 7.85706 10.429V7.42896",
    stroke: "#00AEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyIcon);
export default __webpack_public_path__ + "static/media/buy-icon.43e445896540624f8f388e12902ee469.svg";
export { ForwardRef as ReactComponent };